export default "__VITE_ASSET__aWH4y8D9__"